import * as React from 'react';
import * as Sharing from 'expo-sharing';
import Alert from './alert';
import { Platform, Linking } from 'react-native';

export default async function sharer(base64Data, title = 'Share PDF', filename = '') {
	//if (!(await Sharing.isAvailableAsync())) {

	//this should be open, not download
	if (Platform.OS == 'web') {
		const downloadLink = document.createElement('a');

		downloadLink.href = filename;
		downloadLink.target = '_blank';
		//downloadLink.download = title + (title.endsWith('.pdf') ? '' : '.pdf');
		downloadLink.click();
		return true;
	}

	//non-web, why would we be in this file? Oh, yes we are
	filename &&
		Linking.canOpenURL(filename)
			.then(supported => {
				if (!supported) {
					console.log("Can't handle url: " + base64Data);
				} else {
					return Linking.openURL(filename);
				}
			})
			.catch(err => console.error('An error occurred', err));
	console.warn('Any problems here are just expo');

	return Alert.alert('Sharing problem', `Sharing isn't available on your platform, but it does work from our mobile app! \n Downloading instead`);
	/*}
	console.log('sharing available');
	Alert.alert(filename);
	Sharing.shareAsync(filename, { mimeType: 'document/pdf', dialogTitle: 'You sharing?', UTI: 'com.adobe.pdf' });
	return false;*/
}
